<template>
  <default-layout :breadcrumbs="breadcrumbs">
    <view-skeleton>
      <purchase />
    </view-skeleton>
  </default-layout>
</template>

<script>
import DefaultLayout from '@/layouts/default';
import DefaultHeadMixin from '@/mixins/defaultHead';
import Purchase from '@/components/coins-usage/purchase';
import ViewSkeleton from '@/components/utils/view-skeleton';

export default {
  name: 'index',
  mixins: [DefaultHeadMixin],
  components: {
    DefaultLayout,
    Purchase,
    ViewSkeleton,
  },
  computed: {
    breadcrumbs() {
      const currentName = this.$t('home.sidebarMenu.myCoin');
      return [
        {
          text: this.$t('breadcrumb.homepage'),
          to: '/',
        },
        {
          text: currentName,
          to: this.$router.currentRoute.path,
        },
      ];
    },
  },
};
</script>
